<script type="text/babel">
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export const brandJobSteps = {
    applied: {
        label: 'Godkend anmodning',
        headline: 'Anmodningen afventer dit svar',
        emoji: '🤔',
        description:
            'Du har modtaget en anmodning til din kampagne. Hvis du vælger at godkende anmodningen, vil honoraret blive reserveret på din <a href="/settings/transactions" class="text-white">betterhype konto</a> og influenten vil modtage besked om at påbegynde jobbet.',
    },
    todo: {
        label: 'Afvent indhold',
        headline: 'Tjek - anmodningen er godkendt',
        emoji: '✅',
        description:
            'Anmodningen er nu godkendt og influenten vil påbegynde forberedelse af indhold, du vil snart modtage indhold til godkendelse.',
    },
    inprogress: {
        label: 'Første indhold er klar',
        headline: 'Super - der er noget indhold klar!',
        emoji: '🤳',
        description:
            'Influenten har nu udarbejdet noget eller alt indhold. Du bedes godkende eller afvise indholdet, vi beder dig skrive kommentarer på ikke godkendt indhold.',
    },
    accepted: {
        label: 'Afvent indhold',
        headline: 'Tjek - anmodningen er godkendt',
        emoji: '✅',
        description:
            'Anmodningen er nu godkendt og influenten vil påbegynde forberedelse af indhold, du vil snart modtage indhold til godkendelse.',
    },
    content_received: {
        label: 'Indhold modtaget. Kan du godkende?',
        headline: 'Super - er klar!',
        emoji: '🤳',
        description:
            'Influenten har nu udarbejdet noget indhold. Du bedes godkende eller afvise indholdet, vi beder dig skrive kommentarer på ikke godkendt indhold.',
    },
    content_denied: {
        label: 'Indhold ikke godkendt. Afventer opdatering?',
        headline: 'Afventer indhold!',
        emoji: '🤳',
        description:
            'Du har ikke godkendt indholdet. Influenten er nu igang med at udarbejde forbedringer til indholdet.',
    },
    started: {
        label: 'Opslag på vej',
        headline: 'Super - dit opslag er på vej!',
        emoji: '🤳',
        description:
            'Indholdet er nu blevet godkendt. Du kan nu læne dig tilbage og vente på et link fra influenten, når opslaget er færdigt.',
    },
    finished: {
        label: 'Færdig',
        headline: 'Bum - influenten er nu færdig!',
        emoji: '✌️',
        description:
            'Influenten er nu færdig og du kan se influentens opslag via nedenstående link. Influenten har modtaget sit honorar.',
    },
    declined: {
        headline: 'Din anmodning blev afvist‍',
        emoji: '🤷',
        description:
            'Anmodningen fra influenten er afvist, og du vil ikke kunne modtage flere anmodninger fra influenten til denne kampagne.',
    },
    cancelled: {
        headline: 'Samarbejdet er afbrudt‍',
        emoji: '🚫',
        description:
            'Enten du eller influenten har valgt at afbryde samarbejdet. Du vil få 100% af den aftalte betaling til influenten refunderet.',
    },
}

export default {
    mixins: [ManagesModalState, HasSubscriptions, RestoreOnPageBack],

    props: ['job', 'brand', 'dataInfluencer', 'wantedPostTypes'],

    data() {
        return {
            // job: null,
            loading: false,
            form: new SparkForm({}),
            influencer: this.dataInfluencer,
            recentlySubmittedReview: false,
            steps: brandJobSteps,
            componentKey: 0,
            submitStatusKey: 0,
            showJobContent: false,
            localSubmittedPosts: '',
        }
    },

    computed: {
        reviewSuggestions() {
            return [
                {
                    label: 'Klar anbefaling',
                    text: `${this.influencer.name} har lavet et fantastisk stykke arbejde, og vi er fuldt ud tilfredse. Klar anbefaling herfra.`,
                    rating: 5,
                },
                {
                    label: 'Fint, vi er tilfredse',
                    text: `${this.influencer.name} har lavet et godt stykke arbejde, som matchede vores forventinger.`,
                    rating: 4,
                },
            ]
        },

        postContent() {
            if (!this.job) return

            let postContent = []
            for (var i = 0; i < this.job.posts; i++) {
                postContent.push({
                    number: i + 1,
                })
            }
            return postContent
        },

        platform() {
            return this.$get(this.job, 'jobable.platform')
        },
    },

    created() {
        Bus.$on('jobUpdated', job => {
            if (this.job === null) {
                this.$set(this, 'job', job);
            } else {
                Object.assign(this.job, job);
            }
            this.localSubmittedPosts = this.job.submitted_posts
            this.showJobContent = this.job.status !== 'applied'
        })

        Bus.$on('approveContentMedia', data => {
            let type = data.postContent.post_type
            if (this.job.submitted_posts[type]) {
                // Update form_number status to submitted in data array
                let formNumberIdx = this.job.submitted_posts[type].data.findIndex(
                    d => d.form_number === data.postContent.form_number + 1
                )

                if (formNumberIdx >= 0) {
                    this.job.submitted_posts[type].data[formNumberIdx].status = 'approved_media'
                } else {
                    this.job.submitted_posts[type].data.push({
                        form_number: data.postContent.form_number + 1,
                        status: 'approved_media',
                    })
                }

                // Update count of approved posts
                this.job.submitted_posts[type].count = this.job.submitted_posts[type].data.filter(
                    item => item.status === 'approved_media'
                ).length
                this.submitStatusKey++
            }

            let isCompleted = Object.keys(this.job.submitted_posts).every(type => {
                return this.job.submitted_posts[type].count == this.job.submitted_posts[type].value
            })
            this.$set(this.job.submitted_posts, 'isCompleted', isCompleted)

            if (isCompleted) {
                this.finishJobs(this.job)
            }
        })
    },

    methods: {
        denyContent(job) {
            Spark.post(route('api.job.action', [job.id, 'denyContent']), this.form).then(
                response => {
                    Bus.$emit('jobUpdated', response.data)
                }
            )
        },

        approveContent(job) {
            Spark.post(route('api.job.action', [job.id, 'approveContent']), this.form).then(
                response => {
                    Bus.$emit('jobUpdated', response.data)
                }
            )
        },

        finishJobs(job) {
            this.error = ''
            Spark.post(route('api.job.action', [job.id, 'completeJob']), this.form).then(
                response => {
                    if (response.error) {
                        this.error = response.error
                    } else {
                        Bus.$emit('jobUpdated', response.data)
                    }
                }
            )
        },

        getFields(post_type) {
            const fieldMappings = {
                posts: [
                    { name: 'caption', label: 'Billedtekst', placeholder: '' },
                ],
                stories: [
                    { name: 'hashtag', label: 'Tekst', placeholder: '' },
                ],
                reels: [
                    { name: 'caption', label: 'Billedtekst', placeholder: '' },
                ],
                live: [],
                videos: [
                    { name: 'title', label: 'Titel', placeholder: '' },
                    { name: 'description', label: 'Beskrivelse', placeholder: '' },
                    { name: 'tags', label: 'Tags', placeholder: '' },
                ],
                sponsored: [
                    { name: 'title', label: 'Titel', placeholder: '' },
                    { name: 'description', label: 'Beskrivelse', placeholder: '' },
                    { name: 'tags', label: 'Tags', placeholder: '' },
                ],
                shorts: [
                    { name: 'music', label: 'Musik', placeholder: '' },
                    { name: 'title', label: 'Titel', placeholder: '' },
                    { name: 'hashtag', label: 'Hashtag', placeholder: '' },
                    { name: 'caption', label: 'Billedtekst', placeholder: '' },
                ],
                blog: [
                    { name: 'title', label: 'Titel', placeholder: '' },
                    { name: 'thumbnail', label: 'Miniaturebillede', placeholder: '' },
                ],
            }
            return fieldMappings[post_type] || []
        },

        isMedia(post_type) {
            const mediaTypes = {
                posts: true,
                stories: true,
                reels: false,
                live: false,
                videos: true,
                sponsored: true,
                shorts: false,
                blog: false,
            }
            return mediaTypes[post_type] || false
        },

        isFile(post_type) {
            const fileTypes = {
                live: true,
                blog: true,
            }
            return fileTypes[post_type] || false
        },
    },

    watch: {
        'job.status': {
            immediate: true,
            handler(newStatus) {
                this.showJobContent = newStatus !== 'applied';
            },
        }
    },
}
</script>
